// @flow
import styled from "styled-components"
import { mqMax } from "common/mediaQuery"

export const CategorySelectorWrap = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: auto;
    flex-wrap: wrap;
    margin-bottom: 1rem;

    ${mqMax.phone} {
      margin-left: 1rem;
    }
`

export const ProductCategoryContent = styled.div`
    margin-top:5rem;
    margin-bottom: 1rem;
    margin-left: 1rem;
    margin-right: 1rem;
    display:flex;
    justify-content: center;
    flex-direction: column;
`



// WEBPACK FOOTER //
// ./src/components/ProductCategorySelector/styled.js